// extracted by mini-css-extract-plugin
export default {"lobUploadContainer":"LOBupload_lobUploadContainer__1XOCH","topSpan":"LOBupload_topSpan__R4hAQ"};